
  import { defineComponent, PropType } from 'vue';

  import IconComponent from '@/common/ui/IconComponent.vue';

  import FileBaseMultiUploadRedesigned from './FileBaseMultiUploadRedesigned.vue';

  export default defineComponent({
    components: { IconComponent, FileBaseMultiUploadRedesigned },
    name: 'FileLocalMultiUploadRedesigned',
    emits: ['update:modelValue'],
    props: {
      modelValue: {
        type: Array as PropType<File[]>,
        default: () => [],
      },
      label: String,
      readonly: Boolean,
      required: {
        type: Boolean,
        default: false,
      },
      accept: String,
      description: String,
      title: String,
      subtitle: String,
      showEmpty: {
        type: Boolean,
        default: false,
      },
      isOnce: {
        type: Boolean,
        default: false,
      },
      validExtensions: {
        type: Array as PropType<string[]>,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      titleLevel: {
        type: Number,
        default: 3,
        validator: (value: number) => value >= 1 && value <= 6,
      },
    },
    computed: {
      value: {
        get(): File[] {
          return this.modelValue;
        },
        set(value: File[]) {
          this.$emit('update:modelValue', value);
        },
      },
      headingLevel() {
        return `h${this.titleLevel}`;
      },
      subHeadingLevel() {
        return `h${this.titleLevel + 1}`;
      },
    },
    methods: {
      addFile(file: File) {
        if (this.isOnce) {
          this.value = [file];
        } else {
          this.value.push(file);
        }
      },
      deleteFile(index: number) {
        this.value.splice(index, 1);
      },
    },
  });
